module.exports = __webpack_public_path__ + "static/red_fast_fact-e6524fbfdaffb43b5e006b1feb144901.svg";